export class FullPageIndexer {
  private selected_properties: Set<string> = new Set<string>();
  private all_properties: Array<string> = [];
  constructor(){

  }
  setAllProperties(props: Array<string>) {
    this.all_properties = [];
    for(const id of props){
      if(this.all_properties.indexOf(id) === -1){
        this.all_properties.push(id);
      }
    }
  }
  clearAllPropertiesList() {
    this.all_properties = [];
  }
  selectProperty(id: string) {
    this.selected_properties.add(id);
  }
  deselectProperty(id: string) {
    this.selected_properties.delete(id);
  }
  deselectAll() {
    this.selected_properties.clear();
  }
  selectAll() {
    for(const id of this.all_properties){
      console.debug({id});
      this.selectProperty(id);
    }
  }
  getSelectedProperties() : Array<string> {
    return Array.from(this.selected_properties.keys());
  }
  isSelected(id: string) : boolean {
    return this.selected_properties.has(id);
  }
}
